import tourService from './tourService';

async function openModalWhenUsersFirstTime() {
  const initTour = await tourService.getTourByUser();
  if (initTour.data.section === 'controlRoom' && initTour.data.display === false && initTour.data.seen === false) {
    document.dispatchEvent(new CustomEvent('openTourModal'));
  }
}

function init() {
  openModalWhenUsersFirstTime();
}

export default {
  init,
};
